__turbopack_context__.v({
  "catCard": "ErpNextIntegrations-module__44YQSG__catCard",
  "catDesc": "ErpNextIntegrations-module__44YQSG__catDesc",
  "catGrid": "ErpNextIntegrations-module__44YQSG__catGrid",
  "catHead": "ErpNextIntegrations-module__44YQSG__catHead",
  "catIcon": "ErpNextIntegrations-module__44YQSG__catIcon",
  "catTitle": "ErpNextIntegrations-module__44YQSG__catTitle",
  "catTools": "ErpNextIntegrations-module__44YQSG__catTools",
  "check": "ErpNextIntegrations-module__44YQSG__check",
  "eyebrow": "ErpNextIntegrations-module__44YQSG__eyebrow",
  "grid": "ErpNextIntegrations-module__44YQSG__grid",
  "head": "ErpNextIntegrations-module__44YQSG__head",
  "hiItem": "ErpNextIntegrations-module__44YQSG__hiItem",
  "highlights": "ErpNextIntegrations-module__44YQSG__highlights",
  "logo": "ErpNextIntegrations-module__44YQSG__logo",
  "meta": "ErpNextIntegrations-module__44YQSG__meta",
  "name": "ErpNextIntegrations-module__44YQSG__name",
  "section": "ErpNextIntegrations-module__44YQSG__section",
  "sub": "ErpNextIntegrations-module__44YQSG__sub",
  "subtitle": "ErpNextIntegrations-module__44YQSG__subtitle",
  "tagline": "ErpNextIntegrations-module__44YQSG__tagline",
  "tile": "ErpNextIntegrations-module__44YQSG__tile",
  "title": "ErpNextIntegrations-module__44YQSG__title",
});
